<template>
<div class="chapter">
<div class="inner_page">
<div class="epigraphPage">
<a id="title18"></a>
<div class="verse"><span><strong class="b">Do not do an immoral thing for moral reasons.</strong></span></div>
<div class="source"><span><strong class="b">—Thomas Hardy,</strong> <em class="i"><strong class="b">Jude the Obscure</strong></em></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466806603_epi01.vue?208ed5fe